import '../page.styl';
import './no-match.styl';

function NoMatch() {
  return (
    <div className="page no-match">NoMatch</div>
  );
}

export default NoMatch;